var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4ArrowsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_move",
    "data-name": "icon / move",
    d: "M21.724,11.688l-3.007,3a.97.97,0,0,1-1.4,0,.967.967,0,0,1,0-1.4l1.3-1.3H12V18.6l1.3-1.3a.992.992,0,0,1,1.4,1.4l-3.007,3c-.1.1-.2.2-.3.2a.6.6,0,0,1-.4.1.6.6,0,0,1-.4-.1c-.1-.1-.2-.1-.3-.2l-3.007-3a.992.992,0,0,1,1.4-1.4L10,18.6V11.989H3.383l1.3,1.3a.967.967,0,0,1,0,1.4.91.91,0,0,1-.7.3.91.91,0,0,1-.7-.3l-3.007-3c-.1-.1-.2-.2-.2-.3a1.1,1.1,0,0,1,0-.8c.1-.1.1-.2.2-.3l3.007-3a.992.992,0,0,1,1.4,1.4l-1.3,1.3H10V3.379l-1.3,1.3a.992.992,0,0,1-1.4-1.4l3.007-3c.1-.1.2-.2.3-.2a1.1,1.1,0,0,1,.8,0c.1.1.2.1.3.2l3.007,3a.967.967,0,0,1,0,1.4.97.97,0,0,1-1.4,0L12,3.379V9.986h6.615l-1.3-1.3a.992.992,0,1,1,1.4-1.4l3.007,3c.1.1.2.2.2.3a1.1,1.1,0,0,1,0,.8C21.925,11.488,21.825,11.588,21.724,11.688Z",
    transform: "translate(1 1)",
    fill: "#4332d5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4arrows-icon",
    "data-name": "4arrows-icon",
    transform: "translate(-5364 -527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 31,
    height: 31,
    transform: "translate(5364 527)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_4arrows-icon-2",
    "data-name": "4arrows-icon",
    transform: "translate(5368.176 531)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_move-2",
    "data-name": "icon / move",
    d: "M21.724,11.688l-3.007,3a.97.97,0,0,1-1.4,0,.967.967,0,0,1,0-1.4l1.3-1.3H12V18.6l1.3-1.3a.992.992,0,0,1,1.4,1.4l-3.007,3c-.1.1-.2.2-.3.2a.6.6,0,0,1-.4.1.6.6,0,0,1-.4-.1c-.1-.1-.2-.1-.3-.2l-3.007-3a.992.992,0,0,1,1.4-1.4L10,18.6V11.989H3.383l1.3,1.3a.967.967,0,0,1,0,1.4.91.91,0,0,1-.7.3.91.91,0,0,1-.7-.3l-3.007-3c-.1-.1-.2-.2-.2-.3a1.1,1.1,0,0,1,0-.8c.1-.1.1-.2.2-.3l3.007-3a.992.992,0,0,1,1.4,1.4l-1.3,1.3H10V3.379l-1.3,1.3a.992.992,0,0,1-1.4-1.4l3.007-3c.1-.1.2-.2.3-.2a1.1,1.1,0,0,1,.8,0c.1.1.2.1.3.2l3.007,3a.967.967,0,0,1,0,1.4.97.97,0,0,1-1.4,0L12,3.379V9.986h6.615l-1.3-1.3a.992.992,0,1,1,1.4-1.4l3.007,3c.1.1.2.2.2.3a1.1,1.1,0,0,1,0,.8C21.925,11.488,21.825,11.588,21.724,11.688Z",
    fill: "#4332d5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4ArrowsIcon);
export default __webpack_public_path__ + "static/media/4arrows-icon.d5deea31.svg";
export { ForwardRef as ReactComponent };